<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 20 20" fill="none">
    <path d="M17.0832 5.62501V14.375H18.3332V5.62501H17.0832ZM16.0415 15.4167H3.95817V16.6667H16.0415V15.4167ZM2.9165 14.375V5.62501H1.6665V14.375H2.9165ZM3.95817 4.58334H16.0415V3.33334H3.95817V4.58334ZM2.9165 5.62501C2.9165 5.04971 3.38287 4.58334 3.95817 4.58334V3.33334C2.69252 3.33334 1.6665 4.35936 1.6665 5.62501H2.9165ZM3.95817 15.4167C3.38287 15.4167 2.9165 14.9503 2.9165 14.375H1.6665C1.6665 15.6407 2.69252 16.6667 3.95817 16.6667V15.4167ZM17.0832 14.375C17.0832 14.9503 16.6168 15.4167 16.0415 15.4167V16.6667C17.3072 16.6667 18.3332 15.6407 18.3332 14.375H17.0832ZM18.3332 5.62501C18.3332 4.35936 17.3072 3.33334 16.0415 3.33334V4.58334C16.6168 4.58334 17.0832 5.04971 17.0832 5.62501H18.3332Z" 
    fill="currentColor"/>
    <path d="M8.94454 9.96983L8.54696 10.4521L8.54879 10.4536L8.94454 9.96983ZM11.0554 9.96983L11.4511 10.4536L11.453 10.4521L11.0554 9.96983ZM9.34213 9.48758L3.31421 4.51776L2.51904 5.48223L8.54696 10.4521L9.34213 9.48758ZM16.6857 4.51776L10.6578 9.48758L11.453 10.4521L17.4809 5.48223L16.6857 4.51776ZM8.54879 10.4536C9.39296 11.1442 10.607 11.1442 11.4511 10.4536L10.6595 9.48608C10.2759 9.80008 9.72404 9.80008 9.34038 9.48608L8.54879 10.4536Z" 
    fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: 'EmailIcon',
  props: {
    width: {
      type: Number,
      default: 20
    },
    height: {
      type: Number,
      default: 20
    }
  }
}
</script>

<style scoped></style>